import { __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { IconButton } from '../../iconButton/IconButton.js';
import { CloseIcon } from '../../../icons/CloseIcon.js';
import styles from './CloseButton.module.scss.js';

var CloseButton = function (_a) {
    var className = _a.className, style = _a.style, variant = _a.variant, color = _a.color, onClick = _a.onClick;
    return (jsx(IconButton, __assign({ type: "button", variant: variant || 'contained', color: color || 'secondary', className: clsx(styles['close-button'], className), style: style, "aria-label": "close", onClick: onClick, "data-testid": "modal-close-button", size: "s" }, { children: jsx(CloseIcon, {}) })));
};

export { CloseButton };
